import './PartnerSlot.css';
import type { PartnerPiece } from '../../contracts/partner';
import { t } from '../../copy/strings';

export interface PartnerSlotProps {
  /** Só a faixa por ora (ORD-F-133); o cartão (`card`, §12.5) não foi pedido. Não existe variante modal. */
  variant: 'bar';
  piece: PartnerPiece;
}

/**
 * PartnerSlot `bar` (§12.5; D2 do responsável, ORD-F-133): a faixa do banner acima do TopBar. Um único link estático
 * (imagem e texto servidos por nós; nenhum script nem cookie de terceiro), com o rótulo fixo "Publicidade" em texto
 * visível junto da peça (AC-12.5-03) e `rel="sponsored"` (AC-12.5-06). Quem decide se monta (chave, TV, validade) é o
 * slot (app/partnerSlot.tsx) e a faixa viva (app/partnerLive.tsx).
 */
export function PartnerSlot({ piece }: PartnerSlotProps) {
  const label = t('partner.label');
  const aria = t('partner.bar.aria', {
    label,
    sponsor: piece.sponsor_name,
    text: piece.text ? `${piece.text}. ` : '',
  });
  return (
    <a
      class="partner-slot partner-slot--bar"
      data-testid="partner-bar"
      href={piece.href}
      target="_blank"
      rel="sponsored noopener noreferrer"
      aria-label={aria}
    >
      <span class="partner-slot__label">{label}</span>
      {piece.image ? (
        <img
          class="partner-slot__image"
          src={piece.image.src}
          width={piece.image.width}
          height={piece.image.height}
          alt=""
          decoding="async"
        />
      ) : null}
      <span class="partner-slot__sponsor">{piece.sponsor_name}</span>
      {piece.text ? <span class="partner-slot__text">{piece.text}</span> : null}
      <span class="partner-slot__more">{t('partner.more')}</span>
    </a>
  );
}
